import React, { useEffect, useState } from "react";
import "../styles.css";
import "bootstrap/dist/css/bootstrap.css";
import {
  getWebpageTriggersFilters,
  getWebpageTriggersTypes,
  postWebpageTrigger,
  putWebpageTriggerData,
  getWebpageTriggersFiltersByType,
  getAnalyticsTriggerScript
} from "api/EventTriggerApi";
import { toast } from "react-toastify";
import { useHistory } from 'react-router-dom'
import SupportLink from "../Common/SupportLink";

var filters = [];
function CreateCampaign(props) {
  const history = useHistory()
  const [dropdown, setDropDown] = useState([]);
  const [audienceName, setAudienceName] = useState("");
  const [description, setDescription] = useState("");
  const [anyOrAll, setAnyOrAll] = useState("OR");
  const [isPreview, setIsPreview] = useState(false);

  const [property, setProperty] = useState([]);
  const [action, setAction] = useState([]);
  const [type, setType] = useState([{ id: 0 }, { id: 0 }]);
  const [triggerType, setTriggerType] = useState([]);

  const [editTrigger, setEditTrigger] = useState({});

  const [ts, setTs] = useState("60f553070624d7b2d3bb486e");
  const [onanaltics, setOnAnalytics] = useState(false);

  const [conditionFilters, setConditionFilters] = useState([
    {
      filterPropertyId: null,
      filterActionId: null,
      filterValueTypeId: null,
      filterValue: null,

      sequenceNo: 1,
      logicalOperator: anyOrAll,
      id1: 0,
      id2: 0,
      inputBox: false,
    },
  ]);
  const [firstCheckbox, setFirstCheckbox] = useState(false);
  const [tag, setTag] = useState("");

  const [scriptCode, setscriptCode] = useState("");
  const [showScript, setShowScript] = useState(false);
  let update = true
  // setting previous state defaults for sessionStorage
  let previousStates = { isValid: false };
  previousStates.audienceName = audienceName;
  previousStates.description = description;
  previousStates.firstCheckbox = firstCheckbox;
  previousStates.tag = tag;
  previousStates.anyOrAll = anyOrAll;
  previousStates.conditionFilters = conditionFilters;

  function clearCache() {
    setDropDown([]);
    setAudienceName("");
    setDescription("");
    setAnyOrAll("OR");
    setIsPreview(false);
    try {
      document.getElementById('drop4').value = ''
      document.getElementById('drop4').disabled = false;
    } catch (e) { }

    setProperty([]);
    setAction([]);
    setType([{ id: 0 }, { id: 0 }]);
    setTriggerType([]);

    setEditTrigger({});

    setTs("60f553070624d7b2d3bb486e");
    setOnAnalytics(false);

    setConditionFilters([
      {
        filterPropertyId: null,
        filterActionId: null,
        filterValueTypeId: null,
        filterValue: "",

        sequenceNo: 1,
        logicalOperator: anyOrAll,
        id1: 0,
        id2: 0,
        inputBox: false,
      },
    ]);
    setFirstCheckbox(false);
    setTag("");

    setscriptCode("");
    setShowScript(false);
  }
  // if (sessionStorage.getItem("on_edit_trigger")){
  //   clearCache();
  // }

  useEffect(() => {
    clearCache()

    let ed = sessionStorage.getItem("on_edit_trigger");
    if (ed != null && (ed == "true" || ed == true)) {
      var yy = JSON.parse(sessionStorage.getItem("trigger_edit_"));
      var res = { data: yy };

      document.getElementById("audienceName").value = res.data.name;
      document.getElementById("textArea").value = res.data.description;
      setAudienceName(res.data.name);
      setDescription(res.data.description);
    }
    getWebpageTriggersFilters()
      .then((data) => {
        var ttt = type;

        var yy = data.webpageTriggerFilterValueType;





        var rid;
        for (var i = 0; i < yy.length; i++) {
          if (yy[i].type == "custom") {
            rid = yy[i].id;
            break;
          }
        }
        ttt[1].id = rid;
        setType(ttt);
        setAction(data.webpageTriggerFilterAction);
        setProperty(data.webpageTriggerFilterProperty);
        getWebpageTriggersTypes()
          .then((wtt_data) => {
            setTriggerType(wtt_data);
            let ed = sessionStorage.getItem("on_edit_trigger");
            if (ed != null && (ed == "true" || ed == true)) {
              var yy = JSON.parse(sessionStorage.getItem("trigger_edit_"));
              var res = { data: yy };

              if (res.data.webpageTriggerTypeId.name == 'Web Analytics') {

                getAnalyticsTriggerScript(res.data.id).then((d) => {
                  setscriptCode(d.script);
                  setShowScript(true)
                  scrollToBottom()
                  setOnAnalytics(true)

                })
              }

              setEditTrigger(res.data);

              let temp = [...conditionFilters];
              for (
                var i = 0;
                i < res.data.webpageTriggerFilters.length - 1;
                i++
              ) {
                let objToBeAdded = {
                  filterPropertyId: null,
                  filterActionId: null,
                  filterValueTypeId: null,
                  filterValue: null,

                  sequenceNo: i + 1,
                  logicalOperator: anyOrAll,
                  id1: 0,
                  id2: 0,
                  inputBox: false,
                  id: null,
                };
                temp.push(objToBeAdded);
              }

              // setConditionFilters(temp);

              document.getElementById("audienceName").value = res.data.name;
              document.getElementById("textArea").value = res.data.description;
              document.getElementById("drop4").value =
                res.data.webpageTriggerTypeId.id;
              if (res.data.webpageTriggerTypeId.name == "Web Analytics") {
                document.getElementById("drop4").disabled = true;
              }
              var llf = temp;
              for (var i = 0; i < temp.length; i++) {
                llf[i].id = res.data.webpageTriggerFilters[i].id;
                llf[i].filterPropertyId =
                  res.data.webpageTriggerFilters[
                    i
                  ].webpageTriggerFilterPropertyId.id;

                llf[i].filterActionId =
                  res.data.webpageTriggerFilters[
                    i
                  ].webpageTriggerFilterActionId.id;

                llf[i].filterValue =
                  res.data.webpageTriggerFilters[i].webpageTriggerFilterValue;
              }
              setConditionFilters(llf);



            }
          })
          .catch(function (error) {

          });
      })
      .catch(function (error) {

      });

    if (type[1] != null && type[1] != undefined) {
      for (var i = 0; i < filters.length; i++) {
        filters[i].webpageTriggerFilterValueTypeId = type[1].id;
      }
    }

    if (previousStates.isValid) {
      setAudienceName(previousStates.audienceName);
      setDescription(previousStates.description);
      setFirstCheckbox(previousStates.firstCheckbox);
      setTag(previousStates.tag);
      setAnyOrAll(previousStates.anyOrAll);
      setConditionFilters(previousStates.conditionFilters);
    }
  }, [history.location.search]);
  const scrollToBottom = () => {


    window.scrollTo(0, document.body.scrollHeight);

  }

  //SECTION Preview Audience
  const previewAudience = (e) => {
    e.preventDefault();
    var allFilts = [];
    // 
    // if (!onAll) {
    var s1 = document.getElementsByClassName("s1");
    var s2 = document.getElementsByClassName("s2");
    var ii = document.getElementsByClassName("ii");
    // 

    for (var i = 0; i < s1.length; i++) {
      var a = s1[i].value;
      var b = s2[i].value;
      var c = ii[i].value;
      if (conditionFilters[i].id != null) {
        var x = {
          id: conditionFilters[i].id,
          webpageTriggerFilterPropertyId: a,
          webpageTriggerFilterActionId: b,
          webpageTriggerFilterValueTypeId: type[1].id,
          webpageTriggerFilterValue: c,
        };

        allFilts.push(x);
      } else {
        var x = {
          webpageTriggerFilterPropertyId: a,
          webpageTriggerFilterActionId: b,
          webpageTriggerFilterValueTypeId: type[1].id,
          webpageTriggerFilterValue: c,
        };

        allFilts.push(x);
      }
    }
    //  }


    var x = document.getElementById("drop4").value;
    var saveData = {
      name: audienceName,
      description: description,
      webpageTriggerTypeId: x,

      webpageTriggerFilters: allFilts,
    };

    let triggerName;
    triggerType.forEach(t => {
      if (t.id == x)
        triggerName = t.name
    })
    let ed = sessionStorage.getItem("on_edit_trigger");
    if (ed != null && (ed == "true" || ed == true)) {
      var editID = sessionStorage.getItem("trigger_edit_id");
      var yy = JSON.parse(sessionStorage.getItem("trigger_edit_"));
      var saveData2 = {
        name: audienceName,
        description: description,
        webpageTriggerTypeId: x,
        webpageTriggerFilters: allFilts,
      };

      putWebpageTriggerData(yy.id, saveData2)
        .then((data) => {
          if (triggerName == 'Web Analytics') {
            getAnalyticsTriggerScript(data.id).then((d) => {
              setscriptCode(d.script);
              setShowScript(true)
              scrollToBottom()

            })
          }
          toast.success("The trigger has been created successfully.");
          // props.history.push({
          //   pathname: "/admin/triggersAndEvents/allTrigers",
          // });
        })
        .catch(function (error) {

        });
    } else {
      postWebpageTrigger(saveData)
        .then((data) => {
          if (triggerName == 'Web Analytics') {
            getAnalyticsTriggerScript(data.id).then((d) => {
              setscriptCode(d.script);
              setShowScript(true)
              scrollToBottom()

            })
          }
          toast.success("The trigger has been created successfully.");
          // props.history.push({
          //   pathname: "/admin/triggersAndEvents/allTrigers",
          // });
        })
        .catch(function (error) {

        });
    }
    //  var x = document.getElementById("drop4").value;






  };
  const handleDrop1Change = async (e, filtIndex) => {
    let name = e.target.value;

    let temp = [...conditionFilters];
    temp[filtIndex].filterPropertyId = name;
    setConditionFilters(temp);
  };
  const handleDrop2Change = (e, filtIndex) => {
    let name = e.target.value;

    let temp = [...conditionFilters];
    temp[filtIndex].filterActionId = name;
    setConditionFilters(temp);
  };
  const handleType = (e, filtIndex) => {
    let name = e.target.value;

    let temp = [...conditionFilters];
    temp[filtIndex].filterValue = name;
    setConditionFilters(temp);
  };

  const handleRemove = (id) => {
    const toBeDeleted = [...conditionFilters];

    var s1 = document.getElementsByClassName("s1");
    var s2 = document.getElementsByClassName("s2");
    var ii = document.getElementsByClassName("ii");

    for (var i = 0; i < toBeDeleted.length; i++) {
      var a = s1[i].value;
      var b = s2[i].value;
      var c = ii[i].value;

      toBeDeleted[i].filterPropertyId = a;
      toBeDeleted[i].filterActionId = b;
      toBeDeleted[i].filterValue = c;
    }

    toBeDeleted.splice(id, 1);
    setConditionFilters(toBeDeleted);
  };
  const creatediv = () => {
    let id = conditionFilters.length - 1;
    let sequence = conditionFilters[id].sequenceNo + 1;
    let temp = [...conditionFilters];
    let objToBeAdded = {
      filterPropertyId: null,
      filterActionId: null,
      filterValueTypeId: null,
      filterValue: null,

      sequenceNo: sequence,
      logicalOperator: anyOrAll,
      id1: 0,
      id2: 0,
      id: null,
      inputBox: false,
    };
    temp.push(objToBeAdded);
    setConditionFilters(temp);

  };
  const handleChoice = () => {
    if (document.getElementById("drop4") != null) {
      var x = document.getElementById("drop4").value;
      setOnAnalytics(false)
      triggerType.forEach(t => {
        if (t.id == x && (t.name) == 'Web Analytics') {
          setOnAnalytics(true)
        }

      })

      // let triggerName ;
      // triggerType.forEach(t=>{
      //   if(t.id==x)
      //     triggerName=t.name
      // })
      getWebpageTriggersFiltersByType(x).then((data) => {
        setAction(data.webpageTriggerFilterAction);
        setProperty(data.webpageTriggerFilterProperty);
      });
    }
    // 
  };
  const copy = () => {
    /* Copy the text inside the text field */
    navigator.clipboard.writeText(scriptCode);
  };

  return (
    <div id="crtr">
      {update = !update}
      <SupportLink link='https://kapitalwise.com/user-guide/tags/' />

      <div className="page_heading">
        <h2 >Create Trigger</h2>
      </div>
      <form onSubmit={previewAudience}>
        <div className="audieneOuter">
          <div className="inputOuter">
            <label className="large">Trigger Name</label>
            <input
              id="audienceName"
              value={audienceName}
              onChange={(e) => setAudienceName(e.target.value)}
              type="text"
              placeholder="Enter Trigger Name"
              className="kwDesign max351"
              required
            />
          </div>
          <div className="inputOuter">
            <label className="large">Description</label>
            <textarea
              id="textArea"
              value={description}
              placeholder="Enter Description"
              onChange={(e) => setDescription(e.target.value)}
              className="csTextarea"
              required
            />
          </div>
          <div className="inputOuter">
            {/* <div className="kwCheckboxBlue">
							<input checked={firstCheckbox} onChange={() => setFirstCheckbox(!firstCheckbox)} type="checkbox" id="checkbox1" />
							<label htmlFor="checkbox1" className="kwCheckboxText">
								Tag Audience
							</label>
						</div> */}
          </div>
          <div id="display" className="inputOuter">
            <label className="large">Trigger Type</label>
            <select
              // onChange={(e) => handleDrop1Change(e, filtId)}
              id="drop4"
              className="kwDesign2"
              required
              onChange={handleChoice}
            >
              <option value="">Select</option>

              {triggerType.map((x) => {
                return <option value={x.id}>{x.name}</option>;
              })}
            </select>
          </div>
          {/* <div
            className="kwCheckbox"
            style={{ display: "inline", marginRight: "15px" }}
          >
            <input
              checked={onAll}
              type="checkbox"
              id="logged_in3"
              onChange={handleAll}
            />

            <label className="kwCheckboxText" for="logged_in3">
              All
            </label>
          </div>

          <div
            className="kwCheckbox"
            style={{ display: "inline", marginRight: "15px" }}
          >
            <input
              checked={!onAll}
              type="checkbox"
              id="logged_in4"
              onChange={handleSome}
            />

            <label className="kwCheckboxText" for="logged_in4">
              Some
            </label>
          </div> */}
          {/* <br />
          <br />
          <br /> */}
          {!onanaltics ? (
            <div className="contactMatch" style={{marginLeft:"10px"}}>
              {/* <p className="contactMatchText">
							Contact Match
							<select onChange={(e) => handleAnyOr(e)} id="anyOrand" className="kwDesign1 w69">
								<option value="OR">Any</option>
								<option value="AND">All</option>
							</select>
							of the following conditions.
						</p> */}
            <div className="frjoior">
              <span style={{flex:1}}> Event</span>
              <span  style={{flex:1}} > Condition</span>
              <span  style={{flex:2}}> Condition</span>


            </div>
              <div className="addRemoveDetails">
                {conditionFilters &&
                  conditionFilters.map((filtObj, filtId) => {
                    const parentId = filtObj.id1;
                    const isActive = filtId == 0 ? true : false;



                    //@Boney: Filter options Component starts here

                    return (
                      <ul key={filtId} id="container">
                        <li>
                          <ul className="d-flex align-items-center flex-wrap">
                            <li>
                              <a
                                to=""
                                disabled={isActive}
                                onClick={() => handleRemove(filtId)}
                                className="minusBtn"
                              >
                                <span className="icon-Group-271"></span>
                              </a>
                            </li>
                            <li>
                              <select
                                onChange={(e) => handleDrop1Change(e, filtId)}
                                id={"drop1" + filtId}
                                value={
                                  conditionFilters[filtId].filterPropertyId
                                }
                                className="kwDesign2 s1"
                                required
                              >
                                <option value="">Select</option>

                                {property.map((x) => {
                                  return <option value={x.id}>{x.name}</option>;
                                })}
                                {/* <option value="">Select</option>
														{dropdown
															? dropdown.map((data, index) => (
																<option key={index} value={data.id}>
																	{data.name}
																</option>
															))
															: ""} */}
                              </select>
                            </li>
                            <li>
                              <select
                                onChange={(e) => {
                                  handleDrop2Change(e, filtId);
                                }}
                                id={"drop2" + filtId}
                                className="kwDesign2 s2"
                                value={conditionFilters[filtId].filterActionId}
                                // value={ts}
                                required
                              >
                                <option value="">Select</option>

                                {action.map((x, index) => (
                                  <option key={index} value={x.id}>
                                    {x.name}
                                  </option>
                                ))}
                                {/* {dropdown[parentId]
															? dropdown[parentId].filterActions.map((data, index) => (
																<option key={index} value={data.id}>
																	{data.name}
																</option>
															))

															: ""} */}
                              </select>
                            </li>
                            <li>
                              {/* {conditionFilters[filtId].inputBox ? ( */}
                              <input
                                name={
                                  conditionFilters[filtId].filterValueTypeId ||
                                  ""
                                }
                                id={"typeInput" + filtId}
                                className="kwDesign ii"
                                type="text"
                                value={conditionFilters[filtId].filterValue}
                                onChange={(e) => handleType(e, filtId)}
                                required
                              />
                              {/* // ) : (
													// 	<select id="drop3" className="kwDesign2" */}
                              {/* // 		value={conditionFilters[filtId].filterValue}
													// 		onChange={(e) => handleDrop3Change(e, filtId)} required>
													// 		<option value="">Select</option>
													// 		{dropdown[parentId] */}
                              {/* // 			? dropdown[parentId].filterActions[conditionFilters[filtId].id2] && dropdown[parentId].filterActions[conditionFilters[filtId].id2].filterValues.map((data, index) => (
													// 				<option key={index} */}
                              {/* // 					name={data.id}
													// 					value={data.name}>
													// 					{data.name}
													// 				</option>
													// 			))
													// 			: ""}
													// 	</select>
													// )} */}
                            </li>


                            
                          </ul>
                        </li>
                      </ul>
                    );
                  })}
                <div className="addNewButton">
                  <a to="" onClick={creatediv} className="plusIconText">
                    <span className="icon-Group-272" style={{fontSize:"23px"}} />  <span style={{fontSize:"13px"}} >Add New </span>
                  </a>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="previewAudience" style={{ marginTop: "2vh" }}>
            <input
              type="submit"
              name="Save"
              style={{ margin_top: "2v", cursor: "pointer" }}
              className="lg_btn primary"
              value="Save Trigger"
            />
          </div>
        </div>

        {showScript ? (
          <div
            style={{
              //  width: "90%",
              backgroundColor: "rgba(245, 245, 245,0.5)",
              marginBottom: "120px",
              marginTop: "1%",
              minHeight: "100px",
              borderRadius: "10px",
              padding: "10px",
              marginLeft: "40px",
              marginRight: "40px",

            }}
          >
            <ul>
              <li>
                <a
                  href="#"
                  type="button"
                  onClick={copy}
                  style={{
                    display: "block",
                    marginLeft: "98%",
                    borderWidth: "0px",
                  }}
                >
                  <i class="far fa-copy"></i>
                </a>
              </li>
              <li>
                <code
                  style={{
                    //  backgroundColor: 'grey',
                    fontSize: "large",
                    textAlign: "start",
                  }}
                >
                  {scriptCode}
                </code>
              </li>
            </ul>
          </div>
        ) : (
          ""
        )}
      </form>
    </div>
  );
}

export default CreateCampaign;
